import axios from 'axios';
import { CommonService } from './common.services';
export class InvitacionService extends CommonService {
    async findGruposInvitacionesBy(usuarioEmpresa) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findGruposInvitacionesBy?idUsuarioEmpresa=' + usuarioEmpresa.id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findGrupoInvitacionById(evento, idGrupoInvitaciones) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findGrupoInvitacionById?evento=' + evento + '&id=' + idGrupoInvitaciones, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findInvitacionUnicaBy(evento, idGrupoInvitacion) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findInvitacionUnicaBy?evento=' + evento + '&idGrupoInvitacion=' + idGrupoInvitacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findInvitacionById(evento, id) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findInvitacionById?evento=' + evento + '&id=' + id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async liberarInvitacionBy(evento, idAcreditado) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/liberarInvitacionBy?evento=' + evento + '&idAcreditado=' + idAcreditado, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findInvitacionBy(evento, codigoInvitacion) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findInvitacionBy?evento=' + evento + '&codigoInvitacion=' + codigoInvitacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async findArchivosGruposInvitacionesBy(idGrupoInvitacion) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/findArchivosGruposInvitacionesBy?idGrupoInvitacion=' + idGrupoInvitacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async subirArchivo(archivoGrupoInvitacion) {
        try {
            const response = await axios.post(super.getServerUrl() + '/mobile/subirArchivo?', archivoGrupoInvitacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    async removeFile(archivoGrupoInvitacion) {
        try {
            const response = await axios.get(super.getServerUrl() + '/mobile/removeFile?idArchivoGrupoInvitacion=' + archivoGrupoInvitacion.id, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    getReporteUrl(evento, idGrupoInvitacion) {
        try {
            return super.getServerUrl() + '/mobile/getReporte?evento=' + evento + '&idGrupoInvitacion=' + idGrupoInvitacion;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
    getFileUrl(idArchivoGrupoInvitacion) {
        try {
            return super.getServerUrl() + '/mobile/downloadFile?idArchivoGrupoInvitacion=' + idArchivoGrupoInvitacion;
        }
        catch (error) {
            throw super.manageError(error);
        }
    }
}
